import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {Subscription as RxJsSubscription} from 'rxjs';
import {DiaporamaSearchParams} from '../../diaporama-search-params';
import {Diaporama} from '../../diaporama';
import {Helpers} from '@app/shared';
@Component({
  selector: 'hpf-diaporama-list',
  templateUrl: './diaporama-list.component.html',
  styleUrls: []
})
export class DiaporamaListComponent implements OnInit, OnDestroy {
  /** The filters */
  searchParams = new DiaporamaSearchParams(this.route.snapshot.queryParams);
  /** The search params subscription */
  private paramsSubscription: RxJsSubscription;
  /** Used to open or close filter drawer */
  filtersDrawer = false;
  /** Constructor */
  constructor(private route: ActivatedRoute,
              private router: Router,
              private location: Location) {
  }
  /** Init */
  ngOnInit() {
    // Update query string when params change
    this.paramsSubscription = this.searchParams.subscribe(() => {
      this.location.replaceState('/diaporama', Helpers.toQueryString(this.searchParams.toObject()));
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
  }
  /** Called when the user select a row in the table */
  onSelect(item: Diaporama) {
    this.router.navigateByUrl(`/diaporama/${item.getId()}`);
  }
  /** Called when the user click on create */
  onCreate() {
    this.router.navigate(['/diaporama/create']);
  }
}
